import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function CartPage() {
    const { cartItems, updateQuantity, removeFromCart, cartTotal } = useCart();

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main>
            {/* breadcrumb-area */}
            <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: 'url("img/bg/breadcrumb_bg.jpg")' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h2 className="title">Panier</h2>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Panier</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* breadcrumb-area-end */}

            {/* cart-area */}
            <div className="cart-area pt-110 pb-110">
                <div className="container">
                    {cartItems.length === 0 ? (
                        <div className="text-center">
                            <h3>Votre panier est actuellement vide.</h3>
                            <Link to="/shop" className="btn mt-4">Retour à la boutique</Link>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <div className="cart-wrapper">
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="product-name">Produit</th>
                                                    <th className="product-price">Prix</th>
                                                    <th className="product-quantity">Quantité</th>
                                                    <th className="product-subtotal">Sous-total</th>
                                                    <th className="product-delete" />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cartItems.map((item) => (
                                                    <tr key={item.cartId} style={{ verticalAlign: 'middle' }}>
                                                        <td className="product-name">
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                                <Link to={`/shop/${item.product.slug || '#'}`} style={{ flexShrink: 0 }}>
                                                                    <img
                                                                        src={item.options.images && item.options.images.length > 0 ? item.options.images[0] : (item.product.img || 'img/product/cart_img01.jpg')}
                                                                        alt={item.product.name}
                                                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                                                    />
                                                                </Link>
                                                                <div>
                                                                    <h4 style={{ marginBottom: '5px', fontSize: '16px' }}>
                                                                        <Link to={`/shop/${item.product.slug || '#'}`}>{item.product.name}</Link>
                                                                    </h4>
                                                                    <div style={{ fontSize: '0.85em', color: '#666', lineHeight: '1.4' }}>
                                                                        {item.options.color && <div>Couleur: {item.options.color}</div>}
                                                                        {item.options.size && <div>Taille: {item.options.size}</div>}
                                                                        {item.options.features && Object.entries(item.options.features).map(([key, value]) => (
                                                                            <div key={key}>{key}: {value}</div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="product-price">{item.price.toFixed(2)} TND</td>
                                                        <td className="product-quantity">
                                                            <div className="cart-plus-minus">
                                                                <input type="text" value={item.quantity} readOnly />
                                                                <div
                                                                    className="dec qtybutton"
                                                                    onClick={() => updateQuantity(item.cartId, item.quantity - 1)}
                                                                >-</div>
                                                                <div
                                                                    className="inc qtybutton"
                                                                    onClick={() => {
                                                                        const availableStock = item.product.availableStock || item.product.stock;
                                                                        if (availableStock && item.quantity >= availableStock) {
                                                                            return; // Don't increase if at stock limit
                                                                        }
                                                                        updateQuantity(item.cartId, item.quantity + 1);
                                                                    }}
                                                                >+</div>
                                                            </div>
                                                            <div style={{ fontSize: '0.8em', color: '#666', marginTop: '5px', textAlign: 'center' }}>
                                                                {(() => {
                                                                    const stock = item.product.availableStock || item.product.stock;
                                                                    if (stock) {
                                                                        return stock <= 5 ? `${stock} restant(s)` : `En Stock (${stock})`;
                                                                    }
                                                                    return 'En Stock';
                                                                })()}
                                                            </div>
                                                        </td>
                                                        <td className="product-subtotal"><span>{(item.price * item.quantity).toFixed(2)} TND</span></td>
                                                        <td className="product-delete">
                                                            <a
                                                                href="/#"
                                                                onClick={(e) => { e.preventDefault(); removeFromCart(item.cartId); }}
                                                                style={{ color: '#dc3545', fontSize: '1.2em' }}
                                                                title="Remove item"
                                                            >
                                                                <i className="far fa-trash-alt" />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row mt-30 justify-content-between align-items-center">
                                    <div className="col-md-6 ">
                                        <div className="continue-shopping">
                                            <Link to="/shop" className="btn">Continuer vos achats</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4 mb-40">
                                        <div className="cart-total-box pt-0 border-0" style={{ background: 'none', padding: 0 }}>
                                            <div className="cart-total-inner" style={{ padding: '20px', border: '1px solid #dee2e6', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                                                <div className="d-flex justify-content-between mb-3">
                                                    <span style={{ fontWeight: 'bold', fontSize: '1.2em', color: '#000' }}>Total:</span>
                                                    <span style={{ fontWeight: 'bold', fontSize: '1.2em', color: '#000' }}>{cartTotal.toFixed(2)} TND</span>
                                                </div>
                                                <Link to="/checkout" className="btn btn-block">Passer la commande</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* cart-area-end */}
        </main>
    );
}

export default CartPage;
